import * as io from 'io-ts';

export const arrayOfAny = io.UnknownArray;
export const nullableArrayOfAny = io.union([arrayOfAny, io.null]);
